import React, { PureComponent } from 'react';
// import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import { Modal } from 'antd';
// import { Container } from 'reactstrap';
import EditOrganizationHOC from './EditOrganizationHOC';
import NewOrganization from '../../forms/NewOrganizationForm';
import './EditOrganization.scss';

class EditOrganization extends PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCountryChange: PropTypes.func.isRequired,
    onStateProvChange: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    onAssociationValidationsChange: PropTypes.func.isRequired,
    onResetForm: PropTypes.func.isRequired,
    initialValues: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      iconStatus: PropTypes.string,
      cageCode: PropTypes.string,
      address1: PropTypes.string,
      address2: PropTypes.string,
      address3: PropTypes.string,
      zipCode: PropTypes.string,
      pointofContact: PropTypes.string,
      phoneNumber: PropTypes.string,
      organizationType: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      cntry: PropTypes.string,
      websiteUrl: PropTypes.string,
      industryType: PropTypes.string,
      industryAssociations: PropTypes.string,
      associationValidations: PropTypes.string,
      admins: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          email: PropTypes.string,
          billsbyCustomerId: PropTypes.string,
        }),
      ),
      matchSettingList: PropTypes.shape({
        materials: PropTypes.arrayOf(PropTypes.string),
        methods: PropTypes.arrayOf(PropTypes.string),
        minimumEstimatedCost: PropTypes.number,
        minimumEstimatedQuantity: PropTypes.number,
      }),
    }).isRequired,
    messages: PropTypes.instanceOf(Array).isRequired,
    showEditModal: PropTypes.bool.isRequired,
    closeEditModal: PropTypes.func.isRequired,
  };

  render() {
    const { onSubmit, initialValues, messages, onCountryChange, onStateProvChange, onFieldChange, onResetForm, onAssociationValidationsChange, showEditModal, closeEditModal } = this.props;


    return (
      <div className="nf-add-organization">
        {/* <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Edit Organization Page</title>
        </Helmet> */}
        <Modal
          title={<h3>Edit Organization</h3>}
          visible={showEditModal}
          width="fit-content"
          footer={null}
          onCancel={closeEditModal}
        >
          <NewOrganization
            initialValues={initialValues}
            onSubmit={onSubmit}
            messages={messages}
            onCountryChange={onCountryChange}
            onStateProvChange={onStateProvChange}
            onFieldChange={onFieldChange}
            onAssociationValidationsChange={onAssociationValidationsChange}
            onResetForm={onResetForm}
            closeEditModal={closeEditModal}
          />
        </Modal>
      </div>
    );
  }
}

export default EditOrganizationHOC(EditOrganization);



// WEBPACK FOOTER //
// ./src/components/Modals/EditOrganization/EditOrganization.jsx